import React from "react";
import { Route, Redirect } from "react-router-dom";
import Loader from "assets/img/sideLogo.png";
import Keys from "Keys";

export default function PrivateRoute({ res, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      /* `render`, NOT `component`: <Route component={fn}> does React.createElement(fn, props),
         so an inline arrow is a NEW component type every render — React unmounts and remounts
         the whole routed page (losing all its state) on every App re-render. Any Redux/metaData
         change that re-renders App (e.g. the fleetConfig refetch-on-focus) therefore reset the
         page on window/tab refocus. `render={fn}` just calls fn(props); the returned <Component>
         has a stable type, so re-renders UPDATE it instead of remounting. */
      render={(props) => {
        if (
          window.localStorage.getItem("token") != "" &&
          window.localStorage.getItem("token")
        ) {
          return (
            <div>
              {rest.loader ? (
                <div
                  style={{
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#eeeeee",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <img src={Keys?.logo ? Keys.logo : Loader}></img>
                    {/* <p>Getting things ready ...</p> */}
                  </span>
                </div>
              ) : (
                <Component {...props} />
              )}
            </div>
          );
        } else {
          return <Redirect to="/auth/login" />;
        }
      }}
    />
  );
}
